<template>
    <div class="main">
        <!-- title -->
        <div class="subTitle">
            <el-link icon="el-icon-arrow-left" :underline="false" href="#/clientManagement">Client Management</el-link>
        </div>
        <h3 class="title" content="edit" placement="bottom">
            Create Dummy Account
        </h3>
        <div class="detailContent">
          <div class="requireRmarks">
            *Required Fields
          </div>
            <el-form label-width="50%" label-position="left" ref="formAccount" :model="formAccount" :rules="formAccountRules" >
                <el-row>
                    <h4>Personal Information</h4>
                </el-row>
                <el-row :gutter="50" >
                    <el-col :span="12">
                        <el-form-item label="Dummy Account Type" prop="userType">
                            <el-select v-model="formAccount.userType" :popper-append-to-body="false">
                                <el-option v-for="(item,index) in userTypeList" :key="index" :label="item.name" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Dummy Account Remarks" prop="userTypeRemarks">
                            <el-input v-model="formAccount.userTypeRemarks" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="50">
                    <el-col :span="12">
                        <el-form-item label="Username" prop="userName">
                            <el-input v-model="formAccount.userName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Password" prop="password">
                            <el-input v-model="formAccount.password"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="50">
                    <el-col :span="12">
                        <el-form-item label="Last Name" prop="lastName">
                            <el-input v-model="formAccount.lastName" maxlength="50" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="First Name" prop="firstName">
                            <el-input v-model="formAccount.firstName" maxlength="50" ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="50">
                    <el-col :span="12">
                        <el-form-item label="Middle Name" prop="middleName">
                            <el-input v-model="formAccount.middleName" maxlength="50" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Date Of Birth" prop="dob">
                            <el-date-picker
                                style="width:100%"
                                v-model="formAccount.dob"
                                type="date"
                                format="yyyy/MM/dd"
                                placeholder="Date of Birth"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="50">
                    <el-col :span="12">
                        <el-form-item label="Email Address" prop="email">
                            <el-input v-model="formAccount.email" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                    <h4>Sales Information</h4>
                </el-row>
                <el-row :gutter="50">
                    <el-col :span="12">
                        <el-form-item label="Sales Office" prop="salesOffice">
                            <el-select v-model="formAccount.salesOffice" @change="changeSalesOffice"  :disabled="$store.state.userLevel >= 2">
                                <el-option v-for="(item,index) in salesOfficeList" :key="index" :label="item.name" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Region" prop="region">
                            <el-select v-model="formAccount.region" >
                                <el-option v-for="(item,index) in regionList" :key="index" :label="item.name" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="50">
                    <el-col :span="12">
                        <el-form-item label="Sales Representative Name" prop="representativeName">
                            <el-input v-model="formAccount.representativeName" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <el-row style="padding:25px 0" type="flex" justify="end" :gutter="20">
            <el-col :span="4">
                <el-button class="reset" style="width:100%" @click="handleCancel">Cancel</el-button>
            </el-col>
            <el-col :span="4">
                <el-button type="primary" style="width:100%" @click="handleCreate">Create</el-button>
            </el-col>
        </el-row>
        <!-- Confirm Info -->
        <el-dialog :visible.sync="confirmInfoDialog" width="400px" :close-on-click-modal="false" :show-close="false" custom-class="confirmInfo">
            <h3 style="margin:0 0 15px;font-size:20px;text-align:center;font-weight:bold">Dummy account is created!</h3>
            <p style="font-size:16px;width:75%;margin:0 auto;line-height:1.5">Please copy and send the following Information to the user:</p>
            <el-divider></el-divider>
            <el-row :gutter="20">
                <el-col :span="12" style="text-align:left"><span style="color:#003448">Client ID</span></el-col>
                <el-col :span="12" style="text-align:right"><span style="color:#003448">{{userInfo.clientID}}</span></el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12" style="text-align:left"><span style="color:#003448">Username</span></el-col>
                <el-col :span="12" style="text-align:right"><span style="color:#003448">{{userInfo.username}}</span></el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12" style="text-align:left"><span style="color:#003448">Password</span></el-col>
                <el-col :span="12" style="text-align:right"><span style="color:#003448">{{formAccount.password}}</span></el-col>
            </el-row>
            <el-divider></el-divider>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancel" >Close</el-button>
                <el-button type="primary" @click="handleCopy">Copy</el-button>
            </div>
        </el-dialog>
        <textarea name="copyTxt" id="copyTxt" v-model="copyTxt" style="position:absolute;left:-9999px"></textarea>
    </div>
</template>

<script>
import {
  getSalesOffice,
  getSalesRegion,
  appAddUser,
  getUserType,
} from "@/request/api";
export default {
    name:'createUser',
    data() {
        return {
            formAccountRules:this.$validation.appUserCreate,
            formAccount:{
                userName:'',
                pwd:'',
                userType:'',
                userTypeRemarks:'',
                firstName:'',
                lastName:'',
                middleName:'',
                dob:'',
                email:'',
                salesOffice:'',
                region:'',
                representativeName:'',
            },
            salesOfficeList:[],
            regionList:[],
            userTypeList:[],
            langaugeList:[
                {name:'English',code:'EN'},
                {name:'Traditional Chinese',code:'ZH_HK'},
                {name:'Simplified Chinese',code:'ZH_CN'},
                {name:'Japanese',code:'JA'},
            ],
            confirmInfoDialog:false,
            userInfo:{},
            copyTxt:''
        }
    },
    methods:{
        getUserTypeConfig(){
            getUserType().then(res=>{
                this.userTypeList = [];
                res.data.payload.forEach(item=>{
                    if(item.code != 'CL'){
                        this.userTypeList.push(item)
                    }
                })
            })
        },
        getFilterConfig(){
            getSalesOffice().then(res=>{
                this.salesOfficeList = res.data.payload;
                if(this.$store.state.userLevel >= 2){
                    let salesOffice = this.$store.state.salesOffices[0];
                    this.formAccount.salesOffice = salesOffice;
                    this.changeSalesOffice(salesOffice);
                }
            })
        },
        changeSalesOffice(v,callback){
            this.clearRegion();
            getSalesRegion(v).then(res=>{
                this.regionList = res.data.payload;
                if(callback)callback()
            })
        },
        clearRegion(){
            this.regionList = [];
            this.$set(this.formAccount,"region","")
        },
        handleCancel(){
            this.$router.push('/clientManagement')
        },
        handleCreate(){
            this.$refs.formAccount.validate((valid)=>{
                if(valid){
                    let params = {
                        username:this.formAccount.userName,
                        pwd: this.$encryptedRSAOAEP(this.formAccount.password),
                        userType:this.formAccount.userType,
                        userTypeRemark:this.formAccount.userTypeRemarks?this.formAccount.userTypeRemarks:'',
                        firstName:this.formAccount.firstName?this.formAccount.firstName:'',
                        lastName:this.formAccount.lastName,
                        dob:this.$commonjs.paramFormatDate(this.formAccount.dob,true),
                        email:this.formAccount.email,
                        salesOffice:this.formAccount.salesOffice,
                        region:this.formAccount.region,
                        representative:this.formAccount.representativeName,
                        middleName:this.formAccount.middleName?this.formAccount.middleName:''
                    }
                    appAddUser(params).then(res=>{
                        console.log(res)
                        if(res.data.status=='00'){
                            this.confirmInfoDialog = true;
                            this.userInfo = res.data.payload;
                            this.copyTxt = `Client ID:${this.userInfo.clientID}\nUsername:${this.userInfo.username}\nPassword:${this.formAccount.password}`
                        }else{
                            this.$message.error(res.data.msg)
                        }
                    })
                }else{
                    this.$message.error('Please check the form and fill in correct format')
                }
            })
        },
        handleCopy(){
            let el = document.getElementById('copyTxt');
            el.select();
            document.execCommand('Copy');
            this.$message.success('Copy success')
        },
    },
    created:function(){
        this.getUserTypeConfig();
        this.getFilterConfig();
        this.$set(this.formAccount,'password',this.$commonjs.randomPassword(12));

    }
}
</script>

<style scoped>
.el-row {
    margin-bottom: 20px;
}
.el-row:last-child{
    margin-bottom:0
}
</style>




// WEBPACK FOOTER //
// src/components/appUser/createUser.vue